import { useRef, useState, useEffect, useCallback } from "react";
import { Link, useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from "../../../components/headerBtn/headerBtn";

import ProfileEmployee from '../../../pages/employees/profileEmployee/profileEmployee';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const ProfileSection = () => {
	const { id } = useParams<{ id: string }>();

	const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);
	const { inputValues } = useSelector((state: any) => state.employees.profileEmployees);

	const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
	const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

	const buttonsContainerRef = useRef<HTMLDivElement>(null);

	const sidebarWidth = isOpenSidebar ? 190 : 44;
	const headerFiltersAndSelectWidth = 525;
	const minEmptyWidthForNewBtn = 300;
	const groupBtnWidth = 70;
	const buttonWidth = 130;

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Сохранить"
					purpose="6"
					modalTitle="Сохранить"
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content="Вернуться к списку"
					purpose="navigateToEmployeesList"
					modalTitle="Возврат к списку сотрудников"
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content="Новый сотрудник"
					purpose="createEmployee"
					modalTitle="Новый сотрудник"
				/>
			),
		},
		(!inputValues.fired.fired && {
			component: (
				<HeaderBtn
					content="Уволить"
					purpose="firedAnEmployee"
					modalTitle="Уволить сотрудника"
				/>
			),
		}),
		(inputValues.fired.fired && {
			component: (
				<HeaderBtn
					content="Восстановить"
					purpose="reinstateAnEmployee"
					modalTitle="Сменить/установить вакансию"
				/>
			),
		}),
		(!inputValues.blocked && {
			component: (
				<HeaderBtn
					content="Заблокировать"
					purpose="blockEmployee"
					modalTitle="Заблокировать сотрудника"
				/>
			),
		}),
		(inputValues.blocked && {
			component: (
				<HeaderBtn
					content="Разблокировать"
					purpose="unBlockEmployee"
					modalTitle="Разблокировать сотрудника"
				/>
			),
		}),
		{
			component: (
				<HeaderBtn
					content="Изменить оплату"
					purpose="changeEmployeePay"
					modalTitle="Изменить оплату сотрудника"
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content="Верифицировать фото"
					purpose="verifyPhoto"
					modalTitle="Верифицировать фото"
				/>
			),
		},
	]

	const filteredAvailableButtons = availableButtons.filter((btn: { component: JSX.Element }) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: { component: JSX.Element }, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	useEffect(() => {
		if (
			filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
			filteredAvailableButtons.slice(
				0,
				filteredAvailableButtons.length - overflowedBtnsCount
			).length >
			filteredAvailableButtons.length
		) {
			setOverflowedBtnsCount(0);
		}
	}, [filteredAvailableButtons, overflowedBtnsCount]);

	const handleWindowResize = useCallback(() => {
		const allButtonsWidth =
			filteredAvailableButtons.slice(
				0,
				filteredAvailableButtons.length - overflowedBtnsCount
			).length * buttonWidth;
		const windowWidth = window.innerWidth;
		const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
			? allButtonsWidth >
			windowWidth - headerFiltersAndSelectWidth - sidebarWidth
			: allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

		if (isOverflowed) {
			setIsOpenGroupBtn(true);
			setOverflowedBtnsCount((prevValue: number) => {
				if (overflowedBtnsCount === filteredAvailableButtons.length) {
					return prevValue;
				} else {
					return overflowedBtnsCount + 1;
				}
			});
		}

		const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
			? windowWidth - sidebarWidth - allButtonsWidth + groupBtnWidth > minEmptyWidthForNewBtn
			: allButtonsWidth + groupBtnWidth >
			minEmptyWidthForNewBtn;
		if (isEnoughtSpace) {
			setOverflowedBtnsCount((prevValue: number) => {
				if (prevValue <= 1) {
					setIsOpenGroupBtn(false);
					return 0;
				} else return prevValue - 1;
			});
		}
	}, [filteredAvailableButtons, overflowedBtnsCount, sidebarWidth]);

	useEffect(() => {
		handleWindowResize();
		window.addEventListener('resize', handleWindowResize);

		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, [handleWindowResize]);

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				availableButtons={displayedAvailableBtns}
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				title='Иванов Виктор Петрович'
				pageName='projectInfo'
				section='Сотрудники'
			>
				<div className='content__main'>
					<div className={'btns'}>
						<Link to={`/employees/profile/${id}`} className='tab'>
							<div className='buttons__btn  --active'>Профиль</div>
						</Link>
						{(
							<Link
								to={''}
								className='tab'
							>
								<div className='buttons__btn'>Статистика</div>
							</Link>
						)}
						{<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Документы</div>
						</Link>}
						<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Выплаты</div>
						</Link>
						<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Сертификаты</div>
						</Link>
						<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>Баланс</div>
						</Link>
						<Link
							to={''}
							className='tab'
						>
							<div className='buttons__btn'>История</div>
						</Link>
					</div>
					<ProfileEmployee />
				</div>
			</SectionContent>
		</div>
	);
};

export default ProfileSection;